import { render, staticRenderFns } from "./IntakeFollowUp.vue?vue&type=template&id=2d00c3f3&scoped=true&"
import script from "./IntakeFollowUp.vue?vue&type=script&lang=js&"
export * from "./IntakeFollowUp.vue?vue&type=script&lang=js&"
import style0 from "./IntakeFollowUp.vue?vue&type=style&index=0&id=2d00c3f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d00c3f3",
  null
  
)

export default component.exports